import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["showDeleted", "onlyWithUser"]

  connect() {
    this.initCheckboxState()
  }

  initCheckboxState() {
    const url = new URL(window.location)
    if (this.hasShowDeletedTarget) {
      this.showDeletedTarget.checked = url.searchParams.get("show_deleted") === "true"
    }
    if (this.hasOnlyWithUserTarget) {
      this.onlyWithUserTarget.checked = url.searchParams.get("only_with_user") === "true"
    }
  }

  toggleDeletedRecords(event) {
    this.toggleUrlParam("show_deleted", event.target.checked)
  }

  toggleOnlyWithUser(event) {
    this.toggleUrlParam("only_with_user", event.target.checked)
  }

  toggleUrlParam(param, checked) {
    const url = new URL(window.location)
    if (checked) {
      url.searchParams.set(param, "true")
    } else {
      url.searchParams.delete(param)
    }
    Turbo.visit(url)
  }
}